export const generateRandomId = () => {
  const { crypto } = window;
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);

  const randomValue = array[0];

  return randomValue.toString();
};
